/* eslint-disable jsx-a11y/iframe-has-title */
import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => {
  return [
    { title: 'How It Works' },
    { name: 'description', content: 'Learn how our product works' },
  ]
}

export default function HowItWorksSection({ url }: { url: string }) {
  return (
    <section className="py-16 px-4 max-w-6xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">How It Works</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
        Watch this comprehensive demonstration of our restaurant management platform in action. See how it streamlines operations from recipe creation to inventory management, staff scheduling, and cost control.
        </p>
      </div>

      {/* Responsive video container with proper aspect ratio */}
      <div className="mx-auto rounded-lg overflow-hidden shadow-xl" style={{ maxWidth: "1024px" }}>
        <div className="relative" style={{ paddingBottom: "56.25%" }}>
          <iframe
            src={url}
            frameBorder="0"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
          ></iframe>
        </div>
      </div>
    </section>
  )
}